export { default as PopupNotice } from './PopupNotice'
